import { createModuleBuilder } from '@evidentid/dashboard-commons/app';
import { GatewayApiClient } from '@evidentid/gateway-api-client';
import Logger from '@evidentid/logger';
import Severity from '@evidentid/logger/Severity';
import { Entity } from '@evidentid/tprm-portal-lib/models/dashboard';
import { CollateralEntity } from '@evidentid/tprm-portal-lib/models/entity-details/Collateral/CollateralEntity.model';
import { EntityRequirement } from '@evidentid/tprm-portal-lib/models/entity-details/EntityRequirement.model';
import {
    TprmRequirementModel,
} from '@evidentid/tprm-portal-lib/models/entity-details/TprmRequirementModel.model';
import Tracker from '@evidentid/tracker';

import { Exception } from '@/modules/dashboard/types';
import { AwaitingRequirement } from '@/modules/entity-details/components/OpenVerificationBanner/helpers';
import AMBestRatingDisclaimerProcedure from '@/modules/entity-details/procedures/AMBestRatingDisclaimerProcedure.vue';
import CollateralMappingProcedure from '@/modules/entity-details/procedures/CollateralMappingProcedure.vue';
import ForceSubmissionProcedure from '@/modules/entity-details/procedures/ForceSubmissionProcedure.vue';
import GrantExceptionProcedure from '@/modules/entity-details/procedures/GrantExceptionProcedure.vue';
import RemoveExceptionProcedure from '@/modules/entity-details/procedures/RemoveExceptionProcedure.vue';
import ViewExceptionProcedure from '@/modules/entity-details/procedures/ViewExceptionProcedure.vue';
import ViewHistoricDocumentModalProcedure
    from '@/modules/entity-details/procedures/ViewHistoricDocumentProcedure/ViewHistoricDocumentProcedure.vue';

export const entityDetailsModule = createModuleBuilder()
    .demandContext<{
    gatewayClient: GatewayApiClient;
    tracker?: Tracker<any>;
    logger?: Logger<any>;
}>()
    .registerProcedures<{
    grantExceptionProcedure: { exception: Exception, requirement?: EntityRequirement | null };
    removeExceptionProcedure: { rpName: string, entity: Entity, exceptionIds: string[] };
    aMBestRatingDisclaimerProcedure: {};
    collateralMappingProcedure: { collaterals: CollateralEntity[], entityContactEmail: string, entityId: string };
    forceSubmissionProcedure: {
        rpName: string;
        entity: Entity;
        verificationId: string;
        receivedCount: number;
        awaiting: AwaitingRequirement[];
    };
    viewHistoricDocumentProcedure: {
        rpName: string;
        entity: Entity;
        requirementModels: TprmRequirementModel[];
    };
    viewExceptionProcedure: {
        coverageTypeLabel: string;
        criterionLabel: string;
        overrideTypeLabel: string;
        expirationDate: string;
        note: string | null;
        grantedBy: string;
        date: string;
    };
}>({
        grantExceptionProcedure: GrantExceptionProcedure,
        removeExceptionProcedure: RemoveExceptionProcedure,
        aMBestRatingDisclaimerProcedure: AMBestRatingDisclaimerProcedure,
        collateralMappingProcedure: CollateralMappingProcedure,
        forceSubmissionProcedure: ForceSubmissionProcedure,
        viewHistoricDocumentProcedure: ViewHistoricDocumentModalProcedure,
        viewExceptionProcedure: ViewExceptionProcedure,
    })
    .end();
